export default __webpack_public_path__ + "static/media/bg_hypo.18fb66ce.svg";